export const Data = {
  name: "Manmith Gopari",
  phone: "+91-9133626299",
  roles: [
    "Full Stack Developer",
    "Mobile Developer",
    "Problem Solver"
  ],
  email: "manmithgopari7@gmail.com",
  github: "https://github.com/Manmith7",
  linkedIn: "https://www.linkedin.com/in/manmithgopari7",
  leetcode: "https://leetcode.com/u/ManmithGopari/",
  resume: "", // Add link if available
  description: `I am Manmith Gopari, a passionate developer with experience in web, backend, and mobile development. I enjoy building scalable and maintainable applications, and I am always eager to learn new technologies. My expertise spans Java, Python, C, C++, JavaScript, HTML, CSS, Angular, React, PHP, Bootstrap, jQuery, Node.js, Express, MongoDB, MySQL, PostgreSQL, Laravel, and Kotlin. I am recognized for my problem-solving skills, teamwork, adaptability, and creativity. I am open to exciting opportunities that allow me to contribute and grow in the tech industry.`
};
